import { useState, useEffect } from 'react';
import { useServerProps } from '@shopify/hydrogen';
import clsx from 'clsx';
import { COLLECTION_PAGE_SIZE } from '../../constants';
import Button from '../elements/Button';
import SpinnerIcon from '../icons/Spinner';

type Props = {
  startingCount: number;
};

export default function LoadMoreProducts({ startingCount }: Props) {
  const { pending, serverProps, setServerProps } = useServerProps();
  const [shouldLoadMore, setShouldLoadMore] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const button = document.getElementById('load-more');
      if (!shouldLoadMore && button && isInViewport(button)) {
        setShouldLoadMore(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [shouldLoadMore]);

  useEffect(() => {
    if (shouldLoadMore) {
      handleLoadMore();
    }
  }, [shouldLoadMore]);

  const handleLoadMore = () => {
    setShouldLoadMore(false); // Reset shouldLoadMore after click
    setServerProps(
      'collectionProductCount',
      serverProps.collectionProductCount
        ? serverProps.collectionProductCount + COLLECTION_PAGE_SIZE
        : startingCount + COLLECTION_PAGE_SIZE
    );
  };

  return (
    <div className="flex h-30 items-center justify-center">
      {pending ? (
        <SpinnerIcon />
      ) : (
        <Button
          id="load-more"
          className={clsx(pending && 'opacity-50')}
          disabled={pending}
          onClick={handleLoadMore}
          type="button"
        >
          Load more
        </Button>
      )}
    </div>
  );
}

// Function to check if element is in the viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
